{
  "name": "@onyx.dev/onyx-database",
  "version": "2.8.2",
  "description": "TypeScript client SDK for Onyx Database",
  "keywords": [
    "database",
    "sdk",
    "onyx"
  ],
  "type": "module",
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "edge-light": "./dist/edge.js",
      "worker": "./dist/edge.js",
      "react-server": "./dist/index.js",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.js"
    },
    "./edge": {
      "types": "./dist/edge.d.ts",
      "react-server": "./dist/edge.js",
      "import": "./dist/edge.js",
      "require": "./dist/edge.cjs",
      "default": "./dist/edge.js"
    }
  },
  "bin": {
    "onyx-gen": "dist/gen/cli/generate.cjs",
    "onyx-schema": "dist/schema/cli/schema.cjs"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "sideEffects": false,
  "scripts": {
    "build": "tsup",
    "prepare": "npm run build",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "lint": "eslint .",
    "audit": "npm audit --audit-level=high",
    "benchmark:entity-wire": "vitest bench benchmarks/entity-wire.bench.ts --run --no-color",
    "test": "vitest run --exclude tests/smoke.spec.ts",
    "test:watch": "vitest",
    "test:smoke": "export ONYX_DEBUG=\"true\" && vitest run tests/smoke.spec.ts --coverage=false",
    "prepublishOnly": "npm run build && npm run typecheck",
    "docs": "typedoc",
    "changeset": "changeset",
    "release": "changeset publish",
    "size": "size-limit"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/OnyxDevTools/onyx-database.git"
  },
  "bugs": {
    "url": "https://github.com/OnyxDevTools/onyx-database/issues"
  },
  "homepage": "https://github.com/OnyxDevTools/onyx-database#readme",
  "author": "Onyx DevTools",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "engines": {
    "node": ">=18"
  },
  "devDependencies": {
    "@changesets/cli": "^2.29.6",
    "@size-limit/file": "^11.2.0",
    "@types/node": "^24.3.0",
    "@typescript-eslint/eslint-plugin": "^8.41.0",
    "@typescript-eslint/parser": "^8.41.0",
    "@vitest/coverage-istanbul": "^4.0.13",
    "@vitest/coverage-v8": "^4.0.13",
    "eslint": "^9.34.0",
    "next": "^15.5.15",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "size-limit": "^11.2.0",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.0",
    "typedoc": "^0.28.11",
    "typedoc-plugin-markdown": "^4.8.1",
    "typescript": "^5.9.2",
    "vitest": "^4.0.13"
  },
  "overrides": {
    "postcss": "^8.5.12"
  }
}
